import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-email-template-preview',
  templateUrl: './email-template-preview.component.html',
  styleUrls: ['./email-template-preview.component.scss']
})
export class EmailTemplatePreviewComponent {
  // Used by the template's iframe `(load)` handler to dismiss a
  // skeleton/spinner once the email body finishes rendering.
  loading = true;

  constructor(
    private dialogRef: MatDialogRef<EmailTemplatePreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public email:{subject:String; content:String}
  ) { }
}
